import React from 'react'
import { AccountMenu } from './accountMenu'
import { FeesMain } from './feesMain'
import { PendingSidebar } from './pendingSidebar'

export const Fees = () => {

	return (
		<div className='wallets'>
			<div className='sideBar'>
				<PendingSidebar />
				<AccountMenu />
			</div>
			<FeesMain />
		</div>
	)
}


// WEBPACK FOOTER //
// ./src/components/fees.tsx